import { render } from "./CourseContentBrowser.vue?vue&type=template&id=487c6350"
import script from "./CourseContentBrowser.vue?vue&type=script&lang=js"
export * from "./CourseContentBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__